import { ApiClientError } from "@podecontratar/shared/contract/client-error";

/**
 * Maps an admin API error to a fixed pt-BR message. Never echoes
 * `err.message` (or `err.code`) to the UI — the raw client message can leak
 * request internals (URL, contract-mismatch details) that aren't meant for
 * an operator's screen. Shared by every admin SPA page that reads from
 * `api.request(...)` so the mapping stays in one place.
 *
 * `fallback` is the copy shown for any code this function doesn't special-case
 * (including a write's own business-rule codes, e.g. `not_allowed`) — callers
 * pass an action-appropriate one ("Não foi possível salvar.", not the default
 * read-oriented message) rather than reading `err.message`.
 */
export function mapAdminApiError(err: unknown, fallback = "Não foi possível carregar."): string {
  if (err instanceof ApiClientError) {
    if (err.code === "forbidden") return "Acesso negado. Seu perfil não alcança esta seção.";
    if (err.code === "unauthorized") return "Faça login pra continuar.";
  }
  return fallback;
}
